import cn from 'classnames'
import { Option } from '../..'
import styles from './ComboTextValue.module.scss'

interface ComboTextValueProps<TValue> {
  className?: string
  prefixTextValue?: string
  selectedOptions: Option<TValue>[]
}
export const ComboTextValue = <TValue,>({
  className,
  selectedOptions,
  prefixTextValue = '',
}: ComboTextValueProps<TValue>) => {
  return (
    <div className={cn(styles.container, className)}>
      {selectedOptions.length === 1
        ? selectedOptions[0].label
        : prefixTextValue + ' ' + selectedOptions.length}
    </div>
  )
}
